import { getSafeSearchParams } from '@/config/searchParams';

export const AMP_DEVICE_ID_PARAM = 'amp_device_id';

/**
 * Amplitude device id passed in by the landing page.
 *
 * Without it the funnel starts a device of its own, which splits one visit into two in Amplitude and
 * — more importantly — re-buckets the user in Amplitude Experiment, so the variant the landing showed
 * can differ from the one the quiz runs. WebQuiz has read this param for exactly that reason.
 */
export const readHandoffDeviceId = (search?: URLSearchParams): string | undefined => {
  try {
    const params = search ?? getSafeSearchParams();
    return params.get(AMP_DEVICE_ID_PARAM) || undefined;
  } catch {
    return undefined;
  }
};
